"use client";

import React from "react";
import { Clock, ArrowRight } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const scheduleItems = [{
  time: "08:00",
  title: "Yoga & Morgenmeditation\xA0",
  description: "Sanftes Ankommen im Tag mit einer leichten Yoga Lektion und einer geführten Meditation in der Natur. Du nutzt die Stille des Morgens, um emotionale Klarheit für den Tag zu schaffen."
}, {
  time: "09:30",
  title: "Nährendes Frühstück",
  description: "Eine Auswahl an gesunden, regionalen und pflanzenbasierten Speisen, die den Körper nähren und neue Energie für die kommenden Prozesse spenden."
}, {
  time: "11:00",
  title: "Achtsamkeitspraxis",
  description: "\xA0Fokus Praktische Übungen zur Stressreduktion und zur Förderung der inneren Balance. Du erlernst Techniken, die sich nachhaltig in den Alltag integrieren lassen.\xA0"
}, {
  time: "12:15",
  title: "Mittagspause & Zeit für sich",
  description: "Raum für Reflexion und Integration. Genieße einen Spaziergang durch die angrenzenden Weinreben oder finde Ruhe an einem unserer Rückzugsorte."
}, {
  time: "13:45",
  title: "Energiearbeit & Traumaheilung",
  description: "Intensive, professionell begleitete Sessions im Einzelsetting. Innere Entwicklung und das Lösen tiefliegender Blockaden."
}, {
  time: "18:30",
  title: "Gemeinsames Abendessen",
  description: "Wir bereiten zusammen ein leichtes, wärmendes Abendessen in vertrauensvoller Atmosphäre zu. Zeit für authentischen Austausch mit Gleichgesinnten."
}, {
  time: "21:00",
  title: "Gute Nacht Meditation",
  description: "Wir lassen unseren Geist und Körper zu Ruhe kommen und \xA0schliessen den Tag gemeinsam ab, du verankerst das geerdete spirituelle Wachstum des Tages in deinem Bewusstsein."
}];
function ScheduleItem({
  item,
  index
}: {
  item: (typeof scheduleItems)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    rootMargin: "0px 0px -50px 0px"
  });
  return <div data-index={index} ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="group grid grid-cols-1 md:grid-cols-[120px_1fr] lg:grid-cols-[180px_1fr] gap-4 md:gap-8 py-8 md:py-12">
        {}
        <div className="flex items-start gap-3 text-primary/80 group-hover:text-primary transition-colors duration-300">
          <Clock className="w-5 h-5 mt-0.5 shrink-0" />
          <span className="font-mono text-lg tracking-wider">{item.time}</span>
        </div>

        {}
        <div className="flex flex-col gap-3">
          <h3 className="text-xl md:text-2xl font-serif text-foreground">
            {item.title}
          </h3>
          <p className="text-muted-foreground leading-relaxed max-w-2xl text-base md:text-lg font-light">
            {item.description}
          </p>
          {index === scheduleItems.length - 1}
        </div>
      </div>
      {}
      {index < scheduleItems.length - 1 && <Separator className="bg-border/40 transition-colors duration-300 group-hover:bg-border/80" />}
    </div>;
}
export default function IhrRetreatAblauf() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="ihr-retreat-ablauf" className="dark bg-background text-foreground py-20 md:py-32 relative">
      {}
      <div className="absolute inset-0 bg-secondary/5 pointer-events-none" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[120px] pointer-events-none opacity-50" />

      <div className="container mx-auto px-6 md:px-8 max-w-5xl relative z-10">
        {}
        <div ref={headerRef} className={`max-w-3xl mb-16 md:mb-24 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-3xl md:text-5xl font-serif mb-6 text-foreground">
            Ein Tag im Wandelherz Retreat
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-light leading-relaxed">
            Finde zurück zu deiner inneren Mitte mit einem sorgfältig
            abgestimmten Tagesablauf. Jeder Moment ist darauf ausgerichtet,
            dir Raum für emotionale Klarheit, tiefe Erholung und persönliche
            Transformation zu bieten.
          </p>
        </div>

        {}
        <div className="flex flex-col">
          <Separator className="bg-border/40" />
          {scheduleItems.map((item, i) => <ScheduleItem key={i} item={item} index={i} />)}
          <Separator className="bg-border/40" />
        </div>

        {}
        <div className="mt-16 md:mt-24 flex justify-center">
          <Button asChild variant="outline" size="lg" className="rounded-full px-8 py-6 text-base border-primary/20 hover:bg-primary/10 hover:text-primary transition-all duration-300">
            
          </Button>
        </div>
      </div>
    </section>;
}